import { createContext, useContext, useMemo } from "react"

export const savingsFundContext = createContext()

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} props.reload
 * @param {int} props.colaborador
 * @param {function(boolean):void} props.setReload
 */
export function SavingsFundProvider({ reload, setReload, colaborador, children }) {
	const datos = useMemo(
		() => ({
			reload,
			refreshData: () => setReload((old) => !old),
			colaborador,
		}),
		[colaborador, reload, setReload]
	)

	return (
		<savingsFundContext.Provider value={datos}>
			{children}
		</savingsFundContext.Provider>
	)
}

/**
 * @typedef {Object} ContextType
 * @property {boolean} reload - Indica si se debe recargar.
 * @property {function():void} refreshData - Cambia el valor de reload.
 * @property {int} props.colaborador
 */

/**
 * @returns {ContextType}
 */
export function UseSavingsFundContext() {
	return useContext(savingsFundContext)
}
